// en.js
export default {
  // Login page
  'Please login to your account': 'Please login to your account',
  'Login': 'Login',
  'Forgot Password': 'Forgot password',
  'Back to Login': 'Back to login page',
  'Get Mobile App': 'Get mobile app',
  'Username': 'Username',
  'Password': 'Password',
  'Get Mail': 'Get mail',
  'Password is required': 'Password is required',
  'E-mail is required': 'E-mail is required',
  'E-mail must be valid': 'E-mail must be valid',
  'Scan QR code to download the app': 'Scan QR code to download the app',
  // Set Password
  'Update': 'Update',
  'Set': 'Set',
  'Reset': 'Reset',
  'New Password': 'New password',
  'Confirm Password': 'Confirm password',
  'Show password': 'Show password',
  'Submit': 'Submit',
  'Skip': 'Skip',
  'Back': 'Back',
  'Resend email after 10 mins': 'Resend email after {min} minutes',
  'Must have atleast 8 characeters': 'Must have at-least 8 characters',
  'Its better to have': 'It\’s better to have',
  'Upper & lower case letters': 'Upper and lower case letters',
  'A symbol (#&$)': 'A symbol (#&$)',
  'A numerical value (0-9)': 'A numerical value (0-9)',
  'The longer the password, the better': 'The longer the password, the better',
  // 403 Page
  'Access Denied': 'Access denied',
  'sorry, but you don\'t have permission to access this page.': 'Sorry, but you don\'t have the permission to access this page',
  'You can go back to': 'You can go back to',
  // Navigation
  'Last Update': 'Last update',
  'Home': 'Home',
  'Plant Overview': 'Plant overview',
  'Devices': 'Devices',
  'Alert': 'Alert',
  'Services': 'Services',
  'Support': 'Support',
  'Logout': 'Logout',
  'Admin': 'Admin',
  'For further queries contact': 'For further queries contact',
  // Tool Bar
  'Notification': 'Notification',
  'View more': 'View more',
  'Theme': 'Theme',
  'Auto-Refresh - Every': 'Auto refresh at every',
  'Last Updated': 'Last updated',
  'Single Click - Toggle Auto Reload': 'Single click - toggle auto reload',
  'Double Click - Instant Refresh': 'Double click - instant refresh',
  'Fullscreen': 'Fullscreen',
  'Select Language': 'Select language',
  'Grid': 'Grid',
  'Inverter': 'Inverter',
  // Dashboard change toolbar
  'Dashboard': 'Dashboard',
  // FILTER
  'APPLY': 'APPLY',
  'Filter': 'Filter',
  'Select Date': 'Select date',
  'Start Date': 'Start date',
  'End Date': 'End date',
  'Pick Date': 'Pick date',
  'Select All': 'Select all',
  'Deselect All': 'Deselect all',
  'Select device type': 'Select device type',
  'Choose Date Range': 'Choose date range',
  'Select Date Range': 'Select date range',
  'Last 3 days': 'Last 3 days',
  'Last 7 days': 'Last 7 days',
  'Last 30 days': 'Last 30 days',
  'Present month': 'Present month',
  'Last month': 'Last month',
  'Last 3 months': 'Last 3 months',
  'Present Year': 'Present year',
  'Last year': 'Last year',
  'Last Year': 'Last year',
  'Custom': 'Custom',
  'Severity': 'Severity',
  'Critical': 'Critical',
  'High': 'High',
  'Medium': 'Medium',
  'Low': 'Low',
  'Warning': 'Warning',
  'Info': 'Info',
  'Select an Interval': 'Select an interval',
  'Select Time Range': 'Select time range',
  'Use time range': 'Use time range',
  'Select Date Format': 'Select date format',
  'Select WS': 'Select Weather station(s)',
  'Select Inverters': 'Select inverter(s)',
  'Select Trackers': 'Select tracker(s)',
  'hourly': 'Hourly',
  '30 mins': '30 mins',
  '15 mins': '15 mins',
  '10 mins': '10 mins',
  '5 mins': '5 mins',
  '1 mins': '1 min',
  // HOME
  'Subscription Alert': 'Subscription alert',
  'TOTAL PLANTS': 'TOTAL PLANTS',
  'AC CAPACITY': 'AC CAPACITY',
  'DC CAPACITY': 'DC CAPACITY',
  'ENERGY TODAY': 'ENERGY TODAY',
  'Daily Updates': 'Daily updates',
  'Search': 'Search',
  'NAME': 'NAME',
  'Name': 'Name',
  'LOCATION': 'LOCATION',
  'GEN(kWh)': 'ENERGY TODAY (kWh)',
  'home PR(%)': 'PR (%)',
  'STATUS': 'STATUS',
  'New alert(s)': 'New alert(s)',
  'No alert(s)': 'No alert(s)',
  'MAP View': 'Map View',
  'Filter Search': 'Filter Search',
  'Plant\'s name & Location': 'Plant\'s name & Location',
  'Plant\'s name': 'Plant\'s name',
  'Location': 'Location',
  'Search by location': 'Search by location',
  'Search plants or locations': 'Search plants or locations',
  'Search by plant name': 'Search by plant name',
  'Carbon Footprint(Today)': 'Carbon footprint (Today)',
  'CARBON FOOTPRINT (TODAY)': 'CARBON FOOTPRINT (TODAY)',
  'CARBON FOOTPRINT': 'CARBON FOOTPRINT',
  'Trees Planted Today': 'Trees Planted Today',
  'Eco Savings Today': 'Eco Savings Today',
  'Energy Yesterday': 'Energy Yesterday',
  'Trees Planted Yesterday': 'Trees Planted Yesterday',
  'Eco Savings Yesterday': 'Eco Savings Yesterday',
  'Energy This Month': 'Energy This Month',
  'Trees Planted This Month': 'Trees Planted This Month',
  'Eco Savings This Month': 'Eco Savings This Month',
  'Energy This Year': 'Energy This Year',
  'Trees Planted This Year': 'Trees Planted This Year',
  'Eco Savings This Year': 'Eco Savings This Year',
  'Tree Saplings Planted': 'Tree saplings planted',
  'House Lighted': 'House lighted',
  'Diesel Consumption Reduced': 'Diesel consumption reduced',
  'CO2 emission Reduced': 'CO2 emission reduced',
  'Plant List': 'Plant List',
  'Plant name': 'Plant name',
  'View map': 'View map',
  // PlantOverview
  'Static Plant Info': 'Static Plant Info',
  'Bulletin': 'Bulletin',
  'NO DATA': 'No data',
  'No Data': 'No data',
  'No data': 'No data',
  'no data': 'No data',
  'Plant Details': 'Plant Details',
  'Yet To Compute': 'Yet to compute',
  'Not Available': 'Not available',
  'INV Gen (Today)': 'Inv Energy (Today)',
  'Lifetime Generation (kWh)': 'Lifetime Energy (kWh)',
  'Monthly Revenue': 'Monthly Revenue',
  'Daily Revenue': 'Daily Revenue',
  'INV Gen (Yesterday)': 'Inv Energy (Yesterday)',
  'INV Gen (MTD)': ' Inv Energy (MTD)',
  'INV Gen (YTD)': ' Inv Energy (YTD)',
  'INV Gen (ITD)': ' Inv Energy (ITD)',
  'AC Capacity': 'AC Capacity',
  'DC Capacity': 'DC Capacity',
  'Data Logger Status': 'Data Logger Status',
  'Live Temp': 'Live Temp',
  'AC Power (INV)': 'Inv AC power',
  'Block CUF': 'Block CUF',
  'DC Power (INV)': 'Inv DC power',
  'AC Yield (INV)': 'Inv AC Yield',
  'Peak Power (INV)': 'Inv Peak Power',
  'CUF (INV)': 'Inv CUF',
  'MFM Gen (Today)': 'MFM Energy (Today)',
  'MFM Gen (Yesterday)': 'MFM Energy (Yesterday)',
  'MFM Gen (MTD)': 'MFM Energy (MTD)',
  'MFM Gen (YTD)': 'MFM Energy (YTD)',
  'MFM Gen (FTD)': 'MFM Energy (FTD)',
  'Efficiency': 'Efficiency',
  'Peak Power (MFM)': 'MFM Peak Power',
  'AC Yield (MFM)': 'MFM AC Yield',
  'EM Gen (Today)': 'EM Energy (Today)',
  'EM Gen (Yesterday)': 'EM Energy (Yesterday)',
  'EM Gen (MTD)': 'EM Energy (MTD)',
  'EM Gen (YTD)': 'EM Energy (YTD)',
  'Radiation Insolation': 'Radiation',
  'AC Power (EM)': 'EM AC Power',
  'AC Yield (EM)': 'EM AC Yield',
  'CUF (EM)': 'EM CUF',
  'EM Gen (FTD)': 'EM Energy (FTD)',
  'Peak Power (EM)': 'EM Peak Power',
  'AC Power (MFM)': 'MFM AC Power',
  'Plant AC Yield': 'Plant AC Yield',
  'Inv Start': 'Inv Start',
  'Inv Stop': 'Inv Stop',
  'Inst. PA (%)': 'Inst. PA (%)',
  'Grid Status': 'Grid Status',
  'Plant Availability': 'Plant Availability',
  'Grid Availability': 'Grid Availability',
  'Map View': 'Map View',
  'INV ROOM': 'Inv Room',
  'INV': 'Inv',
  'generation': 'Energy',
  'pr': 'PR',
  'cuf': 'CUF',
  'PR INV': 'Inv PR',
  'EM PR': 'EM PR',
  'MFM PR': 'MFM PR',
  // INVERTER DB
  'Dip Reason': 'Dip Reason',
  'NO ALERTS': 'No Alerts',
  'Created Time': 'Created Time',
  'Resolved Time': 'Resolved Time',
  'Created time': 'Created Time',
  'Resolved time': 'Resolved Time',
  'Block List': 'Block List',
  'Total Inv Gen': 'Total Inv Energy',
  'Generation Graph': 'Energy Graph',
  'Power Graph': 'Power Graph',
  'Plant Total Graph': 'Plant Energy Graph',
  'Plant Total': 'Plant Total',
  'Energy': 'Energy',
  'Power': 'Power',
  'Current': 'Current',
  'Select Graph': 'Select Graph',
  'Graph Type': 'Graph Type',
  'Total': 'Total',
  'Yield': 'Yield',
  'Inverter Wise': 'Inverter-wise',
  'Generation (kWh)': 'Generation (kWh)',
  'Irradiance (W/m²)': 'Irradiance (W/m²)',
  // MFM DB
  'MFM List': 'MFM List',
  'Export (kWh)': 'Export Energy (kWh)',
  'AC Power (KW)': 'AC Power (kW)',
  // MFM Graph
  'R Phase(V)': 'R-Ph Vtg (V)',
  'B Phase(V)': 'B-Ph Vtg (V)',
  'YB-line(V)': 'YB-Line Vtg (V)',
  'Current R(A)': 'R-Ph Curr (A)',
  'Current B(A)': ' B-Ph Curr (A)',
  'AC Power(kw)': 'AC Power (kW)',
  'Export(kWh)': 'Export Energy (kWh)',
  'Temperature(c)': 'Temp (°C)',
  'Y Phase(V)': 'Y-Ph Vtg (V)',
  'RY-line(V)': 'RY-Line Vtg (V)',
  'BR-line(V)': 'BR-Line Vtg (V)',
  'Current Y(A)': 'Y-Ph Curr (A)',
  'Frequency(Hz)': 'Frequency (Hz)',
  'Import(kWh)': 'Import Energy (kWh)',
  'Reactive Power(kVAR)': 'Reactive Pwr (kVAR)',
  // Weather Station
  'Graph': 'Graph',
  'Table': 'Table',
  // Weather Station Header
  'Module Temperature': 'Module Temperature',
  'Ambient Temperature': 'Ambient Temperature',
  'GHI': 'GHI',
  'PoA': 'PoA',
  'Humidity': 'Humidity',
  'Wind Direction': 'Wind Direction',
  'LIVE': 'LIVE',
  'MIN': 'MIN',
  'MAX': 'MAX',
  'AVG': 'AVG',
  'LAST PACKET': 'LAST PACKET',
  'CUMULATIVE': 'CUMULATIVE',
  // Weather Station Graph
  'Irradiance PoA': 'Irradiance PoA',
  'Irradiance GHI': 'Irradiance GHI',
  'Radiation': 'Radiation',
  'Pressure': 'Pressure',
  // TRACKER
  'Accuracy (%)': 'Accuracy (%)',
  'Operation Mode': 'Operation Mode',
  // ADVANCED SCB
  // SCB Table
  'Scb': 'SMB',
  'scb': 'SMB',
  'SCB': 'SMB',
  'Ch Ref Id': 'Ch Ref ID',
  'Channel Ref. Id for Underperforming String': 'Channel Ref. ID for underperforming string',
  'Select All Channels': 'Select all channels',
  'Total Current': 'Total Current',
  'Voltage': 'Voltage',
  'Temp': 'Temp',
  'DC Power': 'DC Power',
  'Breaker Status': 'Breaker Status',
  'SPD Status': 'SPD Status',
  'ON': 'On',
  'OFF': 'Off',
  'Intact': 'Intact',
  'Blown': 'Blown',
  // ZMU
  'Multiplication Factor': 'Multiplication Factor',
  'Total Power': 'Total Power',
  // STRING INVERTER
  'Please select String Inverters in order to check the graph': 'Please select the string inverters in order to check the graph',
  'Please select the channels in order to check graph': 'Please select the channels in order to check the graph',
  'Equipment': 'Equipment',
  'Voltage(V)': 'Voltage (V)',
  'Power(kW)': 'Power (kW)',
  'Temperature(°C)': 'Temperature (°C)',
  // ADVANCED STRING INVERTER
  'Total Power (kW)': 'Total Power (kW)',
  // ZONE MONITORING
  'Channel': 'Channel',
  'Equipment [Block / Room / Device Name]': 'Equipment [Block/ Room/ Device Name]',
  // LIVE DASHBOARD
  'Live Data': 'Live Data',
  'MFM Name': 'MFM Name',
  'Export(kWh)': 'Export Energy (kWh)',
  'Import(kWh)': 'Import Energy (kWh)',
  'INV Name': 'Inv Name',
  'Generation (kWh)': 'Energy (kWh)',
  'AC Yield (Inverter)': 'Inv AC Yield',
  'CUF (Inverter)': 'Inv CUF',
  'CUF (MFM)': 'MFM CUF',
  'EM Name': 'EM Name',
  'SMB Name': 'SMB Name',
  // ALERT
  'Alert': 'Alert',
  'Equipments': 'Equipments',
  'Alert Details': 'Alert Details',
  'New': 'New',
  'Acknowledge': 'Acknowledge',
  'Resolved': 'Resolved',
  'ASC': 'Ascend',
  'DESC': 'Descend',
  'Status': 'Status',
  'Code': 'Code',
  'Manual Alert': 'Manual Alert',
  'communication': 'Communication',
  'Grid Failure': 'Grid Failure',
  'Network Failure': 'Network Failure',
  'Grid Failure/Network Failure': 'Grid failure/Network failure',
  'VCB \'Breaker Name\' Failure': 'VCB\'Breaker name\'Failure',
  'INV Not Started/Failure': 'Inv not started/failure',
  'SCB Failure': 'SMB Failure',
  'SMB Failure': 'SMB Failure',
  'PoA_Value: Out of Range': 'PoA value: Out of range',
  'GHI_Value: Out of Range': 'GHI value: Out of range',
  'Ambient Temperature: Out of Range': 'Ambient temperature: Out of range',
  'Module Temperature: Out of Range': 'Module temperature: Out of range',
  'Wind Direction : Out of Range': 'Wind direction: Out of range',
  'Communication Failure': 'Communication Failure',
  'Grid/Communication Failure': 'Grid/Comm. Failure',
  'Start Time': 'Start Time',
  'Message': 'Message',
  'Alert Message': 'Alert Message',
  'computed': 'Computed',
  'Device': 'Device',
  'Resolve': 'Resolve',
  'Time': 'Time',
  'Updated by': 'Updated by',
  'Added by': 'Added by',
  'Stats': 'Stats',
  // DOWN TIME ANALYSIS
  'DOWN TIME': 'DOWN TIME',
  'Down Time': 'Down Time',
  'DOWN ENERGY': 'DOWN ENERGY',
  'Energy Loss': 'Energy Loss',
  'GRAPH': 'GRAPH',
  'Not Down': 'Not down',
  'Loss': 'Loss',
  'Date': 'Date',
  'State': 'State',
  'Calculated Energy Loss when Solar PV plant is not generating power due to technical failures (Grid/Inverter). This energy is calculated based on the irradiance value and inverter capacity': 
  `Calculated energy loss when solar PV plant is not generating power due to technical failures (Grid/Inverter).  This energy is calculated based on the irradiance value and inverter capacity`,
  'Time when the Solar PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.': 
  `Time when the solar PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.`,
  // FORECAST
  'Next hour forecast': 'Next hour forecast',
  'Irradiance': 'Irradiance',
  'Generation Data': 'Energy generation data',
  'Data upto previous hour': 'Data up to previous hour',
  'Actual Gen': 'Actual energy',
  'Forecasted Gen': 'Forecasted energy',
  'Penalty Trend': 'Penalty trend',
  'Trend compared upto previous hour': 'Trend compared up to previous hour',
  'Today': 'Today',
  'Yesterday': 'Yesterday',
  'Trend': 'Trend',
  'Actual Data vs Forecasted Data': 'Actual data vs Forecasted data',
  'Data comparision for actual generation vs forecasted generation': 'Data comparison for actual energy generated vs forecasted energy generated',
  'Deviation': 'Deviation',
  'Revision': 'Revision',
  'Trend Table': 'Trend Table',
  'Generation/weather parameters trend': 'Energy/Weather parameters’ trend',
  'Actual': 'Actual',
  'Forecast': 'Forecast',
  'Range and Deviation': 'Range and Deviation',
  'Trend': 'Trend',
  'Generation vs Penalty': 'Energy vs Penalty',
  'Data compared to deviation range': 'Data compared to deviation range',
  'Range': 'Range',
  'Penalty': 'Penalty',
  'Previous Revision Id': 'Previous Revision ID',
  'Forecast Generation (MWh)': 'Forecast Energy (MWh)',
  'sunny': 'Sunny',
  'mostly sunny': 'Mostly sunny',
  'partly sunny': 'Partly sunny',
  'intermittent clouds': 'Intermittent clouds',
  'hazy sunshine': 'Hazy sunshine',
  'mostly cloudy': 'Mostly cloudy',
  'cloudy': 'Cloudy',
  'dreary (overcast)': 'Overcast',
  'fog': 'Fog',
  'showers': 'Showers',
  'mostly cloudy w/ showers': 'Mostly cloudy with showers',
  'partly sunny w/ showers': 'Partly sunny with showers',
  't-storms': 'T-Storms',
  'mostly cloudy w/ t-storms': 'Mostly cloudy with T-storms',
  'partly sunny w/ t-storms': 'Partly sunny with T-storms',
  'rain': 'Rain',
  'flurries': 'Flurries',
  'mostly cloudy w/ flurries': 'Mostly cloudy with flurries',
  'partly sunny w/ flurries': 'Partly sunny with flurries',
  'snow': 'Snow',
  'mostly cloudy w/ snow': 'Mostly cloudy with snow',
  'ice': 'Ice',
  'sleet': 'Sleet',
  'freezing rain': 'Freezing rain',
  'rain and snow': 'Rain and snow',
  'hot': 'Hot',
  'cold': 'Cold',
  'windy': 'Windy',
  'clear': 'Clear',
  'mostly clear': 'Mostly clear',
  'partly cloudy': 'Partly cloudy',
  'hazy moonlight': 'Hazy moonlight',
  'partly cloudy w/ showers': 'Partly cloudy with showers',
  'partly cloudy w/ t-Storms': 'Partly cloudy with T-storms',
  // OTHER SENSOR
  'SHOW DETAILS': 'SHOW DETAILS',
  'Block': 'Block',
  'Inverter Room': 'Inverter Room',
  'Sensor Time': 'Sensor Time',
  'Sensor Reading Time': 'Sensor Reading Time',
  'Import Cumulative (kWh)': 'Cumm Import (kWh)',
  'Export Cumulative (kWh)': 'Cumm Export (kWh)',
  'Total Import (kWh)': 'Total Imp Energy (kWh)',
  'Total Export (kWh)': 'Total Exp Energy (kWh)',
  'R-Phase (kV)': 'R-Ph Vtg (kV)',
  'Y-Phase (kV)': 'Y-Ph Vtg (kV)',
  'B-Phase (kV)': 'B-Ph Vtg (kV)',
  'Frequency (Hz)': 'Frequency (Hz)',
  'L1 (A)': 'R-Ph Curr (A)',
  'L2 (A)': 'Y-Ph Curr (A)',
  'L3 (A)': 'B-Ph Curr (A)',
  'Daily Import (kWh)': 'Daily Imp Energy (kWh)',
  'Daily Export (kWh)': 'Daily Exp Energy (kWh)',
  'AC Power (kW)': 'AC Power (kW)',
  'Peak Power (kW)': 'Peak Power (kW)',
  'Reactive Power (kW)': 'Reactive Pwr (kVAR)',
  'Soiling Ratio 1 (%)': 'Soiling Ratio 1 (%)',
  'Soiling Ratio 2 (%)': 'Soiling Ratio 2 (%)',
  'Transmit Loss 1 (%)': 'Transmit Loss 1 (%)',
  'Transmit Loss 2 (%)': 'Transmit Loss 2 (%)',
  'Ref Module Temp(°C)': 'Ref. Module Temp (°C)',
  'Test Module Temp(°C)': 'Test Module Temp (°C)',
  'SR Daily Avg(%)': 'SR Daily Avg (%)',
  'SP Daily Avg(%)': 'SP Daily Avg (%)',
  'Geff Ref(W/m²)': 'Geff Ref (W/m²)',
  'Geff Test(W/m²)': 'Geff Test (W/m²)',
  'ISC Ref(A)': 'Isc Ref (A)',
  'ISC Test(A)': 'Isc Test (A)',
  'Soil Ratio(%)': 'Soil Ratio (%)',
  'Soil Percentage(%)': 'Soil Percentage (%)',
  'AC output voltage (V)': 'AC O/P Vtg (V)',
  'AC input voltage (V)': 'AC I/P Vtg (V)',
  'Battery Voltage (V)': 'Battery Vtg (V)',
  'Current Load (kW)': 'Current Load (kW)',
  'Invalid Voltage(V)': 'Invalid Vtg (V)',
  'Battery Temperature(°C)': 'Batt. Temp (°C)',
  'Actual OT (°C)': 'Actual OT (°C)',
  'Actual WT (°C)': 'Actual WT (°C)',
  'Max OT (°C)': 'Max OT (°C)',
  'Max WT (°C)': 'Max WT (°C)',
  'OT Alarm Set (°C)': 'OT Alarm Set (°C)',
  'OT Trip Set (°C)': 'OT Trip Set (°C)',
  'WT Alarm Set (°C)': 'WT Alarm Set (°C)',
  'WT Trip Set (°C)': 'WT Trip Set (°C)',
  'Tracker Angle': 'Tracker Angle',
  'Actual Angle': 'Actual Angle',
  'Input Voltage': 'Input Vtg',
  'Deviation Angle': 'Deviation Angle',
  'Mode Status': 'Mode Status',
  'Wind Speed': 'Wind Speed',
  'Error Status': 'Error Status',
  'Breaker ON': 'Breaker On',
  'Breaker OFF': 'Breaker Off',
  'Breaker Trip': 'Breaker Trip',
  'Local': 'Local',
  'Remote': 'Remote',
  'Test': 'Test',
  'Spring Charge': 'Spring Charge',
  'Trip Circuit': 'Trip Ckt',
  'DC Supply': 'DC Supply',
  // INVERTER RANKING
  'Overall Performance': 'Overall Performance',
  'Overall performance info': 'Overall Performance Info',
  'Overall performance of inverter is derived from individual ranking buckets. Lower the points (pts) will be considered as higher in performance.': 'Overall performance of inverter is derived from individual ranking buckets. Lower the points (pts) will be considered as higher in performance.',
  'Ranking Trends': 'Ranking Trends',
  'Present Month': 'Present Month',
  'Last Month': 'Last Month',
  'up': 'Up',
  'down': 'Down',
  'Best': 'Best',
  'Least': 'Least',
  'others': 'Others',
  'Other best inv': 'Other Best Inv',
  'Other least inv': 'Other Least Inv',
  'Best Performing Inverter': 'Best Performing Inv',
  'trend compared to prior month\'s PR': 'Trend compared to prior month\'s PR',
  'Highest ranked Inverters': 'Highest Ranked Inv',
  'Best inverters': 'Best Inv',
  'Present & Last month': 'Present and Previous Month',
  'PRESENT': 'PRESENT',
  'LAST': 'LAST',
  'Trend compared to prior month (%)': 'Trend compared to prior month (%)',
  'Current month\'s PR (%)': 'Current Month\'s PR (%)',
  'Prior month\'s PR (%)': 'Prior Month\'s PR (%)',
  'PR\'S NOT CONFIGURED': 'PR\'S NOT CONFIGURED',
  'Inverter Ranking based on': 'Inverter ranking based on',
  'sorted in descending order': 'Sorted in descending order',
  'Performance Summary': 'Performance Summary',
  'Performance info': 'Performance Info',
  'viewing based on': 'Viewing based on',
  'Overall Performance based on': 'Overall performance based on',
  'Data Table': 'Data Table',
  'Aggregate values for all parameters': 'Aggregate values for all parameters',
  'Heat Map': 'Heat Map',
  'Inverter data visualization vs parameters': 'Inverter data visualization vs Parameters',
  'Down Time(min)': 'Down Time (min)',
  'Down\nTime Energy(kWh)': 'Down Time Energy (kWh)',
  'AC Yield(kW)': 'AC Yield (kWh/kW)',
  'Efficiency(%)': 'Efficiency (%)',
  'Above 80': 'Above 80',
  'Between 75 & 80': 'Between 75 to 80',
  'Below 75': 'Below 75',
  'Above 98': 'Above 98',
  'Between 90 & 98': 'Between 90 to 98',
  'Below 90': 'Below 90',
  'Generation above "4*Inv DC Capacity)"': 'Generation above "4 x DC Cap of Inv"',
  'Above 4': 'Above 4',
  'Between 3.5 & 4': 'Between 3.5 to 4',
  'Below 3.5': 'Below 3.5',
  'Below 10 min': 'Below 10 mins',
  'Between 10min & 15min': 'Between 10mins to 15mins',
  'More than 15min': 'More than 15mins',
  'Below 60': 'Below 60',
  'Between 60 & 100': 'Between 60 & 100',
  'More than 100': 'More than 100',
  'Total Points': 'Total Points',
  // SLD
  'Value 0': 'Value 0',
  'Any value 1': 'Any Value 1',
  'IN/OUT TAG': 'In/Out Tag',
  'Change View to': 'Change view to',
  'Input': 'Input',
  'Output': 'Output',
  'Value': 'Value',
  // CUSTOM REPORT
  'Fetching Report': 'Fetching report..',
  'REPORTS': 'REPORTS',
  'No template configured': 'No template configured',
  'Plant Level': 'Plant Level',
  'Block Level': 'Block Level',
  'Device Level': 'Device Level',
  'INV Level Gen': 'Inv Level Energy',
  ' INV Gen': 'Inv Energy',
  'EM Level Gen': 'EM Level Energy',
  ' EM Gen': 'EM Energy',
  'MFM Level Gen': 'MFM Level Energy',
  ' Performance Report': 'Performance Report',
  ' Summary Report': 'Summary Report',
  ' Device Report': 'Device Report',
  'Inverter level generation report': 'Inv Level Energy Report',
  'Plant level inverter generation report': 'Plant Level Inv Energy Report',
  'Block level inverter generation': 'Block Level Inv Energy',
  'Energy meter level generation report': 'EM Level Energy Report',
  'MFM level generation report': 'MFM Level Energy Report',
  'Plant level energy meter generation report': 'Plant Level EM Energy Report',
  'Device Level Performance Report': 'Device Level Performance Report',
  'Plant Summary Report': 'Plant Summary Report',
  'Block Level Device Report': 'Block Level Device Report',
  'GRAPHICAL REPORTS': 'GRAPHICAL REPORTS',
  'TABULAR REPORTS': 'TABULAR REPORTS',
  'POA Insolation (kWh/m²)': 'PoA Insolation (kWh/m²)',
  'INV GEN (kWh)': 'Inv Energy (kWh)',
  'POA (W/m²)': 'PoA (W/m²)',
  // PLANT ANALYTICS
  'SAVE TEMPLATE': 'SAVE TEMPLATE',
  'Plant Analogue': 'Plant Analogue',
  'Plant KPI\'s': 'Plant KPI\'s',
  'Select Plants/Devices': 'Select Plants/Devices',
  'Select Parameters': 'Select Parameters',
  'KPI\'s are inverter based': 'KPI\'s are Inv based',
  'RETRIEVE': 'RETRIEVE',
  'Retrieve the Saved Templates': 'Retrieve the saved templates',
  'Plot Graph/Table': 'Plot Graph/Table',
  'VIEW': 'VIEW',
  'Save As Template': 'Save as template',
  'Select Options in order to check data at Plant Level or Device Level': 'Select options in order to check data at plant level or device level',
  'Are you sure, you wanna delete this template': 'Are you sure, you want to delete this template?',
  'You can only save upto 5 Templates max.Please remove one of the Pre-saved Template, in order to proceed.': 'You can only save up to max of 5 templates. Please remove one of the pre-saved template, in order to proceed.',
  'Please Select Parameters': 'Please select the parameters',
  'Template Saved Successfully': 'Template saved successfully',
  'Failed to save template!': 'Failed to save template',
  'Template Deleted Successfully': 'Template deleted successfully',
  'Failed to delete template!': 'Failed to delete template',
  'Please Select Plant/Parameters': 'Please select plant/parameters',
  'Refresh': 'Refresh',
  'Download Image': 'Download as image',
  'Download CSV': 'Download in CSV',
  'Enter Template Name': 'Enter template name',
  'Search Plant': 'Search Plant',
  'Search Device': 'Search Device',
  // INVERTER CONTROL
  'CONTROL': 'CONTROL',
  'CHANGE INVERTER STATE': 'CHANGE INVERTER STATE',
  'Change inverter state': 'Change Inverter State',
  'CHANGE SELECTED INVERTER STATE': 'CHANGE SELECTED INVERTER STATE',
  'Are you sure to change': 'Are you sure to change?',
  'Sorry Connection Lost with Device': 'Sorry, connection lost with device',
  'Updated Successfully': 'Updated successfully!',
  'Failed! Retry again': 'Failed! Please try again',
  'Username or password entered is incorrect': 'Username or password entered is incorrect',
  'Enter the Password': 'Enter the password',
  'Email': 'Email',
  'Password': 'Password',
  'Reject': 'Reject',
  'Please Enter Power Factor Value Between': 'Please enter Power Factor value between',
  'Please enter an interger': 'Please enter an integer',
  'Please Enter Active Power Value Between': 'Please enter an Active Power value between',
  'Please Enter Reactive Power Value Between': 'Please enter an Reactive Power value between',
  'Are You Sure To Change': 'Are you sure to change?',
  'Are you sure you want to change the state': 'Are you sure you want to change the state?',
  'Connected': 'Connected',
  'Connection Lost': 'Connection lost',
  'Current status of': 'Current status of',
  'is': 'is',
  'is currently': 'is currently',
  'POWER FACTOR': 'POWER FACTOR',
  'REACTIVE POWER': 'REACTIVE POWER',
  'ACTIVE POWER': 'ACTIVE POWER',
  // Archive
  'Archive': 'Archive',
  'Data is available per week': 'Data is available per week',
  'Archive Content': 'Archive content',
  'Reset': 'Reset',
  'File': 'File',
  'Date From': 'Date from',
  'Date To': 'Date to',
  'Actions': 'Actions',
  'Rows per page:': 'Rows per page:',
  // String Evaluation
  'String Evaluation': 'String Evaluation',
  'Ref String': 'Ref. String',
  'Ref Value': 'Ref. Value',
  'Channel': 'Channel',
  'Current (A)': 'Current (A)',
  'Deviation (%)': 'Deviation (%)',
  'Evaluation': 'Evaluation',
  // THINK HOME
  'DATA LOGGERS': 'DATA LOGGERS',
  'Performance Ratio': 'Performance Ratio',
  'DC CAPACITY': 'DC CAPACITY',
  'ENERGY TODAY': 'ENERGY TODAY',
  'Monthly PR': 'Monthly PR',
  'Annual PR': 'Annual PR',
  'Monthly CUF': 'Monthly CUF',
  'Annual CUF': 'Annual CUF',
  'City': 'City',
  'Yield (kWh/kWp)': 'Yield (kWh/kWp)',
  'Insolation': 'Insolation',
  'PR (%)': 'PR (%)',
  'Refresh': 'Refresh',
  'Download CSV': 'Download in CSV',
  'Your search for': 'Your search for',
  'found no results': 'No results found',
  'Plant Alerts': 'Plant Alerts',
  'Download': 'Download',
  'Select an alert': 'Select an alert',
  'Please select an option': 'Please select an option',
  'There was some error while loading the data. Please try again!!': 'There was some error while loading the data. Please try again!',
  // REPORT
  'Select Interval': 'Select Interval',
  'Select Device': 'Select Device',
  'Select INV ROOM': 'Select Inv Room',
  'Select Block': 'Select Block',
  'Selected date exceeds 30 day': 'Selected date exceeds 30 day',
  'No Data for Specific Date\'s': 'No data for specific date\'s',
  'No Data Available': 'No data available',
  'Cannot download data more than 15 days': 'Cannot download data more than 15 days',
  'Cannot download data more than a month': 'Cannot download data more than a month',
  'Cannot Download data beyond 180 days': 'Cannot download data beyond 180 days',
  'Please Select an interval': 'Please select an interval',
  'Please Select valid parameters': 'Please select valid parameters',
  'Please Select a Device': 'Please select a device',
  'Device Name': 'Device Name',
  // Legend text
  'Known Issue': 'Known issue',
  'Under Performing': 'Underperforming',
  'String Underperforming': 'String underperforming',
  'String deviation': 'String deviation',
  'Comm Error': 'Comm. error',
  'NC': 'NC',
  'Selected': 'Selected',
  'On / Healthy / Okay': 'On / Healthy / Okay',
  'Off / Fault / Not Okay': 'Off / Fault / Not Okay',
  'No Communication': 'No Communication',
  // COMMON TERMINOLOGY
  'Show Graph': 'Show Graph',
  'Show Table': 'Show Table',
  'Selected Items': 'Selected Items',
  'Clear Selection': 'Clear Selection',
  'Clear All': 'Clear All',
  'Live': 'Live',
  'Average': 'Average',
  'Avg': 'Avg',
  'Computed': 'Computed',
  'Raw': 'Raw',
  'Note': 'Note',
  'Not Connected': 'Not Connected',
  'Click to make it stick': 'Click to pin it',
  'Cancel': 'Cancel',
  'Send': 'Send',
  'UP': 'UP',
  'DOWN': 'DOWN',
  'Reason': 'Reason',
  'Remarks': 'Remarks',
  'Parameters': 'Parameters',
  'Any Comments': 'Any comments',
  'NO': 'NO',
  'YES': 'YES',
  'Yes': 'Yes',
  'select': 'Select',
  'Select': 'Select',
  // COMMON HEADER
  'EM Generation': 'EM Energy',
  'Generation': 'Energy',
  'PR': 'PR',
  'GHI Insolation': 'GHI Insolation',
  'Wind Speed': 'Wind Speed',
  'Temperature': 'Temperature',
  'PoA Insolation': 'PoA Insolation',
  'Loading': 'Loading',
  'Indicates required field': 'Indicates required field',
  'This field is required': 'This field is required',
  'SUBMIT': 'SUBMIT',
  'N/A': 'N/A',
  'n/a': 'N/A',
  'Close': 'Close',
  'Hey, Wait': 'Hey, wait!',
  'Disagree': 'Disagree',
  'Agree': 'Agree',
  'CANCEL': 'CANCEL',
  'SAVE': 'SAVE',
  // Progress Bar
  'Please Wait': 'Please wait',
  'Loading': 'Loading',
  // GLOBAL PARAMETERS
  // Devices
  'Annunciator': 'Annunciator',
  'annunciator': 'Annunciator',
  'EM': 'Energy Meter',
  'Energy Meter': 'Energy Meter',
  'energy meter': 'Energy Meter',
  'MFM': 'MFM',
  'mfm': 'MFM',
  'SMB': 'SMB',
  'smb': 'SMB',
  'Weather Station': 'Weather Station',
  'weather station': 'Weather Station',
  'ZMU': 'ZMU',
  'zmu': 'ZMU',
  'MPPT': 'MPPT', 
  'mppt': 'MPPT', 
  'Relay': 'Relay',
  'relay': 'Relay',
  'Soil Sensor': 'Soil Sensor',
  'soil sensor': 'Soil Sensor',
  'Tracker': 'Tracker',
  'tracker': 'Tracker',
  'Transformer': 'Transformer',
  'transformer': 'Transformer',
  'UPS': 'UPS',
  'ups': 'UPS',
  'Grid': 'Grid',
  'grid': 'Grid',
  'Inverter': 'Inverter',
  'inverter': 'Inverter',
  'Gateway Comm.': 'Gateway Comm.',
  'Breaker': 'Breaker',
  'breaker': 'Breaker',
  'Computed.': 'Computed',
  'gateway': 'Gateway',
  'computed': 'Computed',
  // ANNUNCIATOR
  'Device ID': 'Device ID',
  'Molg Alarm': 'MOLG alarm',
  'OC EF Trip': 'OC EF Trip',
  'UV OV Trip': 'UV OV Trip',
  'Master Trip': 'Master Trip',
  'TF OTI Trip': 'TF OTI Trip',
  'TF WTI Trip': 'TF WTI Trip',
  'TF OTI Alarm': 'TF OTI Alarm',
  'TF WTI Alarm': 'TF WTI Alarm',
  'TF Bchlz Trip': 'TF Bchlz Trip',
  'TF Bchlz Alarm': 'TF Bchlz Alarm',
  // BREAKER
  'Local': 'Local',
  'Remote': 'Remote',
  'Trip Circuit Healthy': 'Trip Ckt Healthy',
  'DC Supply': 'DC Supply',
  'Breaker On': 'Breaker On',
  'Breaker OFF': 'Breaker Off',
  'Breaker Trip': 'Breaker Trip',
  'Spring Charge': 'Spring Charge',
  // ENERGY METER
  'GA (%)': 'GA (%)',
  'PA (%)': 'PA (%)',
  'PR (%)': 'PR (%)',
  'R-Phase (V)': 'R-Ph Vtg (V)',
  'Y-Phase (V)': 'Y-Ph Vtg (V)',
  'B-Phase (V)': 'B-Ph Vtg (V)',
  'Line Current 12 (A)': 'RY Ln Curr (A)',
  'Line Current 23 (A)': 'YB Ln Curr (A)',
  'Line Current 31 (A)': 'BR Ln Curr (A)',
  'CUF (%)': 'CUF (%)',
  'RY-Line (V)': 'RY Ln Vtg (V)',
  'YB-Line (V)': 'YB Ln Vtg (V)',
  'BR-Line (V)': 'BR Ln Vtg (V)',
  'R-Phase-Thd (V)': 'R-Ph THD (V)',
  'Y-Phase-Thd (V)': 'Y-Ph THD (V)',
  'B-Phase-Thd (V)': 'B-Ph THD (V)',
  'AC Power (kW)': 'AC Power (kW)',
  'AC Yield (kW)': 'AC Yield (kWh/kW)',
  'Frequency (Hz)': 'Frequency (Hz)',
  'AC Power L1 (kW)': 'AC Power 1 (kW)',
  'AC Power L2 (kW)': 'AC Power 2 (kW)',
  'AC Power L3 (kW)': 'AC Power 3 (kW)',
  'Temperature (°C)': 'Temperature (°C)',
  'Power Factor (kW)': 'Power Factor',
  'Apparent Power (kW)': 'Apparent Power (kVA)',
  'Apparent Power 1 (kW)': 'Apprnt Power 1 (kVA)',
  'Apparent Power 2 (kW)': 'Apprnt Power 2 (kVA)',
  'Apparent Power 3 (kW)': 'Apprnt Power 3 (kVA)',
  'R-Phase (A)': 'R-Ph Curr (A)',
  'Y-Phase (A)': 'Y-Ph Curr (A)',
  'B-Phase (A)': 'B-Ph Curr (A)',
  'Power Factor': 'Power Factor',
  'Power Factor 1 (kW)': 'Power Factor 1',
  'Power Factor 2 (kW)': 'Power Factor 2',
  'Power Factor 3 (kW)': 'Power Factor 3',
  'Reactive Power (kVAR)': 'Reactive Power (kVAR)',
  'Reactive Power 1 (kW)': 'Reactive Power 1 (kVAR)',
  'Reactive Power 2 (kW)': 'Reactive Power 2 (kVAR)',
  'Reactive Power 3 (kW)': 'Reactive Power 3 (kVAR)',
  'R-Phase-Thd (A)': 'R-Ph Curr THD (A)',
  'Y-Phase-Thd (A)': 'Y-Ph Curr THD(A)',
  'B-Phase-Thd (A)': 'B-Ph Curr THD (A)',
  'V Line Neutral AVG (kW)': 'Line-Neutral Avg (kV)',
  'Active Export Day (kWh)': 'Active Export Day (kWh)',
  'Active Import Day (kWh)': 'Active Import Day (kWh)',
  'Lifetime Generation (KWh)': 'Lifetime Energy (kWh)',
  'Active Export Cumm. (kWh)': 'Active Exp Cumm. (kWh)',
  'Active Import Cumm. (kWh)': 'Active Imp Cumm. (kWh)',
  'Cumm. Active Export Cumm. (kWh)': 'Cumm. Active Export Cumm. (kWh)',
  'Cumm. Active Import Cumm. (kWh)': 'Cumm. Active Import Cumm. (kWh)',
  // INVERTER
  'AC Generation (kWh)': 'AC Energy (kWh)',
  'Load 1 (kW)': 'Load 1 (kW)',
  'Load 2 (kW)': 'Load 2 (kW)',
  'Load 3 (kW)': 'Load 3 (kW)',
  'AC Yield (kW)': 'AC Yield (kWh/kW)',
  'BOS loss (kW)': 'BoS Loss (kW)',
  'DC Power (kW)': 'DC Power (kW)',
  'DC Yield (kW)': 'DC Yield (kWh/kWp)',
  'DC Generation (kWh)': 'DC Energy (kWh)',
  'Down Time (kWh)': 'Down Time (mins)',
  'Grid Lost': 'Grid Lost',
  'R-Phase (V)': 'R-Phase (V)',
  'Y-Phase (V)': 'Y-Phase (V)',
  'B-Phase (V)': 'B-Phase (V)',
  'Stop Time': 'Stop Time (mins)',
  'DC Current (A)': 'DC Current (A)',
  'DC Voltage (V)': 'DC Voltage (V)',
  'Efficiency (%)': 'Efficiency (%)',
  'Max Energy (kW)': 'Max Energy (kW)',
  'Min Energy (kW)': 'Min Energy (kW)',
  'Start Time': 'Start Time',
  'AC Power L1 (kW)': 'AC Power L1 (kW)',
  'AC Power L2 (kW)': 'AC Power L2 (kW)',
  'AC Power L3 (kW)': 'AC Power L3 (kW)',
  'Down Energy (kWh)': 'Down Energy (kWh)',
  'Energy Today (kWh)': 'Energy Today (kWh)',
  'Inv OP State': 'Inv Oprt State',
  'Working Hour': 'Working Hour',
  'Energy Import (kW)': 'Import Energy (kWh)',
  'Inv Temp (°C)': 'Inv Temp (°C)',
  'R-Phase (A)': 'R-Phase (A)',
  'Y-Phase (A)': 'Y-Phase (A)',
  'B-Phase (A)': 'B-Phase (A)',
  'Min DC Energy (kW)': 'Min DC Energy (kWh)',
  'Apparent Power (kW)': 'Apparent Power (kW)',
  'BOS Efficiency (%)': 'BoS Efficiency (%)',
  'Inverter Temp 2 (°C)': 'Inverter Temp-2 (°C)',
  'POA Irradiance (W/m²)': 'PoA Irradiance (W/m²)',
  'Inv Status': 'Inverter Status',
  'Leakage Current': 'Leakage Current (A)',
  'Inverter Status 1': 'Inverter Status 1',
  'Inverter Status 2': 'Inverter Status 2',
  'Inverter Status 3': 'Inverter Status 3',
  'Inverter Status 4': 'Inverter Status 4',
  'Cumm. AC Generation (kWh)': 'Cumm. AC Energy (kWh)',
  'DC Cabinet Status': 'DC Cabinet Status',
  'Off Grid Frequency (Hz)': 'Off Grid Frequency (Hz)',
  'Total Working Hour': 'Total Working Hour',
  'Energy Import Daily (kW)': 'Daily Import Energy (kWh)',
  'Lifetime Generation (KWh)': 'Lifetime Energy (kWh)',
  'DC Cabinet OC Status': 'DC Cabinet O/C Status',
  // MFM
  'V Line Avg (V)': 'Avg Ln Vtg (V)',
  'Apparent Power Avg (kWA)': 'Avg Apprnt Pwr (kVA)',
  'Total Avg Current (A)': 'Total Avg Curr (A)',
  'V Line Neutral AVG (kW)': 'L-N Avg Vtg (kV)',
  'Power (kW)': 'Power (kW)',
  'Energy (kWh)': 'Energy (kWh)',
  'Channel (A)': 'Channel (A)',
  'Voltage (V)': 'Voltage (V)',
  'Over Volt': 'Over Vtg',
  'Earth Trip': 'Earth Trip',
  'Phase Trip': 'Phase Trip',
  'Under Volt': 'Under Vtg',
  'Unit Ready': 'Unit Ready',
  'Earth Fault': 'Earth Fault',
  'Fuse Failure': 'Fuse Failure',
  'Internal Fault': 'Internal Fault',
  'Breaker Status': 'Breaker Status',
  'SPD Status': 'SPD Status',
  'Total Current (A)': 'Total Current (A)',
  // SOIL SENSOR
  'ISC Ref (A)': 'Isc Ref. (A)',
  'GEFF Ref (W/m²)': 'Geff Ref. (W/m²)',
  'ISC Test (A)': ' Isc Test (A)',
  'GEFF Test (W/m²)': ' Geff Test (W/m²)',
  'Soil Ratio (%)': 'Soil Ratio (%)',
  'SP Daily Avg (%)': 'SP Daily Avg (%)',
  'SR Daily Avg (%)': 'SR Daily Avg (%)',
  'Percentage Ratio 1': 'Percentage Ratio 1',
  'Percentage Ratio 2': 'Percentage Ratio 2',
  'Soiling Ratio 1': 'Soiling Ratio 1',
  'Soiling Ratio 2': 'Soiling Ratio 2',
  'Transmit Loss 1': 'Transmit Loss 1',
  'Transmit Loss 2': 'Transmit Loss 2',
  'Ref Module Temp (°C)': 'Ref. Module Temp (°C)',
  'Soil Percentage (%)': 'Soil Percentage (%)',
  'Test Module Temp (°C)': 'Test Module Temp (°C)',
  // TRACKER
  'Current (A)': 'Current (A)',
  'Accuracy (%)': 'Accuracy (%)',
  'Wind Speed (km/h)': 'Wind Speed (m/s)',
  'Mode Status': 'Mode Status',
  'Actual Angle (°)': 'Actual Angle (°)',
  'Error Status': 'Error Status',
  'Target Angle (°)': 'Target Angle (°)',
  'Input Voltage (V)': 'Input Voltage (V)',
  'Deviation Angle (°)': 'Deviation Angle (°)',
  // TRANSFORMER
  'PRV': 'PRV',
  'Mog Trip': 'MOLG Trip',
  'Mog Alarm': 'MOLG Alarm',
  'OT Trip Set (°C)': 'OT Trip Set (°C)',
  'WT Trip Set (°C)': 'WT Trip Set (°C)',
  'OT Alarm Set (°C)': 'OT Alarm Set (°C)',
  'WT Alarm Set (°C)': 'WT Alarm Set (°C)',
  'Actual OT (°C)': 'Actual OT (°C)',
  'Actual WT (°C)': 'Actual WT (°C)',
  'Buchloz Trip': 'Bchlz Trip',
  'Max OT (°C)': 'Max OT (°C)',
  'Max WT (°C)': 'Max WT (°C)',
  'Buchloz Alarm': 'Bchlz Alarm',
  // UPS
  'On Battery': 'On Battery',
  'Bypass': 'By-pass',
  'Health': 'Health',
  'Backup Time': 'Back-up Time',
  'Load (kW)': 'Load (kW)',
  'Power Factor': 'Power Factor',
  'B-Phase (A)': 'B-Ph Curr (A)',
  'Battery Current (A)': 'Battery Curr (A)',
  'Battery Volt (V)': 'Battery Vtg (V)',
  'Invalid Voltage (V)': 'Invalid Vtg (V)',
  'AC I/P Curr (A)': 'AC I/P Curr (A)',
  'AC I/P Volt (V)': 'AC I/P Vtg (V)',
  'O/P Frequency (Hz)': 'O/P Freq. (Hz)',
  'AC O/P Curr (A)': 'AC O/P Curr (A)',
  'AC O/P Volt (V)': 'AC O/P Vtg (V)',
  'Rectifier Voltage (V)': 'Rectifier Vtg (V)',
  'Battery Temperature (°C)': 'Batt. Temp. (°C)',
  // WEATHER STATION
  'Humidity': 'Humidity',
  'Pressure (atms)': 'Pressure (Atms)',
  'Pressure': 'Pressure',
  'Direction (deg)': 'Direction (°)',
  'Direction': 'Direction',
  'Radiation (W/m²)': 'Radiation (W/m²)',
  'Radiation': 'Radiation',
  'Rain Gauge (mm)': 'Rain Gauge (mm)',
  'Rain Gauge': 'Rain Gauge',
  'Roll Angle (Radian)': 'Roll Angle (Radian)',
  'Roll Angle': 'Roll Angle',
  'Wind Speed (m/s)': 'Wind Speed (m/s)',
  'Wind Speed': 'Wind Speed',
  'Cloud Cover': 'Cloud Cover',
  'Module Temp (°C)': 'Module Temp (°C)',
  'Module Temp': 'Module Temp',
  'Pitch Angle (Radian)': 'Pitch Angle (Radian)',
  'Pitch Angle': 'Pitch Angle',
  'Ambient Temp (°C)': 'Ambient Temp (°C)',
  'Ambient Temp': 'Ambient Temp',
  'GHI Insolation (kWh/m²)': 'GHI Insolation (kWh/m²)',
  'GHI Insolation': 'GHI Insolation',
  'POA Insolation (kWh/m²)': 'PoA Insolation (kWh/m²)',
  'POA Insolation': 'PoA Insolation',
  'Aux Supply (V)': 'Aux Supply (V)',
  'Aux Supply': 'Aux Supply',
  'POA (W/m²)': 'PoA (W/m²)',
  'POA': 'POA',
  'GHI (W/m²)': 'GHI (W/m²)',
  'GHI': 'GHI',
  // ZMU
  'DC Power (kW)': 'DC Power (kW)',
  'DC Current (A)': 'DC Current (A)',
  'DC Voltage (V)': 'DC Voltage (V)',
  'Total ZMU Power (kW)': 'Total ZMU Power (kW)',
  'Computed DC Power (kW)': 'Computed DC Power (kW)',
  'Total ZMU Current (A)': 'Total ZMU Current (A)',
  'Computed DC Current (A)': 'Computed DC Current (A)',
  'Total Computed ZMU Power (kW)': 'Total Computed ZMU Power (kW)',
  'Total Computed ZMU Current (A)': 'Total Computed ZMU Current (A)',
  // ERROR MESSAGES
  'Error': 'Error',
  'Warning': 'Warning',
  'Successful': 'Successful',
  'Success': 'Success',
  'Unknown Error': 'Unknown error',
  'Not Found': 'Not found',
  'Invalid date': 'Invalid date',
  'Unable to read cache components': 'Unable to read cache components',
  'Cache not found': 'Cache not found',
  'Cache could not be deleted': 'Cache could not be deleted',
  'Cannot update without condition': 'Cannot update without condition',
  'Something went wrong': 'Something went wrong',
  'Some error occured': 'Some error occurred',
  'Error while reading data': 'Error while reading data',
  'Plants are not assigned to this user': 'Plants are not assigned to this user',
  'The specified key does not exist.': 'The specified key does not exist.',
  'Too many requests, please try again later.': 'Too many requests, please try again later.',
  'Not a Registered User': 'Not a registered user',
  'Invalid Password': 'Invalid Password',
  'This Login Has Expired': 'This login has expired',
  'Some issue in the server': 'Some issue in the server',
  'Date Limit Exceeded!': 'Date limit exceeded!',
  'Session has expired expired': 'Session has expired',
  'no records': 'No records',
  'Plant ID is required': 'Plant ID is required',
  'Block ID is required': 'Block ID is required',
  'Inverter room is required': 'Inverter room is required',
  'Index is required': 'Index is required',
  'Query param is required': 'Query parameter is required',
  'Date is required': 'Date is required',
  'Date from is required': 'Date from is required',
  'Date to is required': 'Date to is required',
  'Date from can not be greater than Date to': 'Date from cannot be greater than Date to',
  'Starting date is required': 'Starting date is required',
  'Ending date is required': 'End date is required',
  'Component param is required': 'Component param is required',
  'Type is required': 'Type is required',
  'Type param is required': 'Type param is required',
  'Ending date required': 'End date required',
  'Starting date required': 'Starting date required',
  'Interval is required': 'Interval is required',
  'Module is required': 'Module is required',
  'Device is required': 'Device is required',
  'ID list is required': 'ID list is required',
  'Inverter ID is required': 'Inverter ID is required',
  'SMB ID is required': 'SMB ID is required',
  'WS ID is required': 'WS ID is required',
  'Search list is required': 'Search list is required',
  'Email is required': 'Email is required',
  'Not a valid email': 'Not a valid email',
  'The password must be 3+ chars long and contain a number': 'The password must be 3+ chars long and must contain a number',
  'You are not allowed to make an API call': 'You are not allowed to make an API call',
  'Login expired': 'Login expired',
  'Alert updated successfully': 'Alert updated successfully',
  'Alert update failed!': 'Alert update failed!',
  'Please select a valid date': 'Please select a valid date',
  'Please select some option': 'Please select some option',
  'Changes were saved successfully': 'Changes were saved successfully',
  'Failed to save the changes': 'Failed to save the changes',
  'Please select String Inverters in order to check graph': 'Please select String Inverters in order to check graph',
  'No File To Download': 'No file to download',
  'Template is successfully updated': 'Template is successfully updated',
  'There was some issue while making the change': 'There was some issue while making the change',
  'Template is successfully created': 'Template is successfully created',
  'Template has been deleted': 'Template has been deleted',
  'Forecasted Generation is not edited!': 'Forecasted generation is not edited!',
  'Parameters are not configured': 'Parameters are not configured',
  'Please enter a valid Email': 'Please enter a valid email',
  'Please check email for further instructions': 'Please check email for further instructions',
  'Please try again after': 'Please try again after',
  'Invalid email': 'Invalid email',
  'Please enter a valid date to view dashboard': 'Please enter a valid date to view dashboard',
  'Not-Connected channel cannot be selected': 'Not Connected channel cannot be selected',
  'Please select atleast one SMB or Channel in order to plot graph': 'Please select at-least one SMB or Channel in order to plot graph',
  'Minimun one device will be selected': 'At least one device must be selected',
  'This link has expired': 'This link has expired',
  'Please fill new password and confirm password!': 'Please fill new password and confirm again!',
  'Password does not match': 'Password does not match',
  'Your password should not be same as your previous password': 'Your password should not be same as your previous password',
  'Password Successfully Updated! Email is sent with password in it': 'Password successfully updated! Email is sent with new password in it',
  'Password Update Failed': 'Password update failed',
  'Your password is not strong. Please fulfill the criteria!': 'Your password is not strong. Please fulfil the criteria!',
  'Could not go back to login page, please try again': 'Could not go back to login page, please try again',
  'You have 10 days to reset the password': 'You have {num} days to reset the password',
  'Please Select Any Component': 'Please select any component',
  'Minimun one tracker will be selected': 'At least one tracker must be selected',
  'No ZMU Configured': 'No ZMU is configured',
  'Please Select Channel/ZMU': 'Please select Channel/ZMU'
};
